@if(service.viewDroplistItems.length){
<div class='admissions-accelerators-views-part'>

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.Accelerators) {
	<admissions-accelerators-accelerators-view-part></admissions-accelerators-accelerators-view-part>
	}
	@case (service.viewId.Teams) {
	<admissions-accelerators-teams-view-part></admissions-accelerators-teams-view-part>
	}
	@case (service.viewId.AcceleratorSeats) {
	<admissions-accelerators-accelerator-seats-view-part></admissions-accelerators-accelerator-seats-view-part>
	}
	}
	}
</div>
}